/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_organization_add_team_skip = /** @type {(inputs: {}) => string} */ () => {
	return `Omitir por ahora`
};

const en_organization_add_team_skip = /** @type {(inputs: {}) => string} */ () => {
	return `Skip for now`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const organization_add_team_skip = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.organization_add_team_skip(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("organization_add_team_skip", locale)
	if (locale === "es") return es_organization_add_team_skip(inputs)
	return en_organization_add_team_skip(inputs)
};
export { organization_add_team_skip as "organization.add_team.skip" }